import DrawerLayout from "client/common/components/stackables/DrawerLayout";
import { useCurrentDrawer } from "client/common/hooks/stackables";
import Markdown from "client/common/components/content/Markdown";
import { useFeatures } from "client/clinics/hooks";

import { useControlledSubstanceGuidanceQuery } from "../../hooks";

/**
 * @deprecated Superseded by /api/client/v1/controlled-substances/guidance/. Read only when
 * Feature.ControlledSubstanceShippingAddressBasis is off, and deleted with that flag.
 */
const CONTROLLED_SUBSTANCES_INFO = `
Drugs classified as a controlled substance require a special prescription process in alignment with federal and/or state regulations.

You must be over the age of 18 and your Date of Birth and/or Driver’s License Number* may be required to place an order. Drugs included in a state prescription drug monitoring program (PDMP) may also require your Date of Birth and/or Driver’s License Number*. Please see requirements below.

**Federally controlled substances include:**
- Phenobarbital
- Tramadol

**State controlled substances include:**
- Gabapentin — *AL, KY, MI, ND, TN, VA, WV.*
- Proin - *IA, LA, MS, WV.*
- Xylamed - *OH, WV.*

| **Drug** | **States requiring D.O.B.**                                                                    | **States requiring Driver's License*** |
|--------------------------|------------------------------------------------------------------------------------------------|---------------------------------------------|
| Gabapentin               | AL, AR, CT, LA, MN, ND, OH, VA, WI, WV, WY                                                     | MI                                          |
| Phenobarbital            | AL, AR, AZ, CA, CO, CT, FL, IN, LA, MD, ME, MN, MS, MT, NC, ND, NH, OH, OK, TX, VA, WI, WV, WY | MI                                          |
| Proin                    | AL, AR, CT, LA, MN, ND, OH, VA, WI, WV, WY                                                     | -                                           |
| Tramadol                 | AL, AR, AZ, CA, CO, CT, FL, IN, LA, MD, ME, MN, MS, MT, NC, ND, NH, OH, OK, TX, VA, WI, WV, WY | MI                                          |
| Xylamed                  | OH, WV                                                                                         | -                                           |

**Adult signature is required at delivery. Please ensure an adult will be available to provide a signature for your package at the delivery address.**

Please note you may experience slightly longer fulfillment times. The pharmacy must receive verbal authorization from your veterinarian before dispensing controlled substances.

To learn more about controlled substances, please visit the U.S. Drug Enforcement Administration site [here](https://www.dea.gov/drug-information/csa).

*State identification number may be required in the absence of a driver's license.`;

const ControlledSubstanceGuidanceDrawer = () => {
  const { close } = useCurrentDrawer();
  const usesGuidanceEndpoint = useFeatures().CONTROLLED_SUBSTANCE_SHIPPING_ADDRESS_BASIS;
  const {
    data: guidance,
    isLoading,
    error,
  } = useControlledSubstanceGuidanceQuery({ enabled: usesGuidanceEndpoint });

  if (usesGuidanceEndpoint) {
    if (isLoading) {
      return <DrawerLayout.Loading />;
    }
    if (!guidance || error) {
      return (
        <DrawerLayout.FetchError error={error} entityName="controlled substance information" />
      );
    }
  }

  return (
    <DrawerLayout>
      <DrawerLayout.Header
        title={guidance?.title ?? "Controlled substances information"}
        onClose={close}
      />
      <DrawerLayout.Content>
        <Markdown markdown={guidance?.body ?? CONTROLLED_SUBSTANCES_INFO} />
      </DrawerLayout.Content>
    </DrawerLayout>
  );
};

export default ControlledSubstanceGuidanceDrawer;
